import { render } from "./NotFound404.vue?vue&type=template&id=eacfba94&scoped=true"
const script = {}

import "./NotFound404.vue?vue&type=style&index=0&id=eacfba94&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./NotFound404.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eacfba94"]])

export default __exports__